import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';
const Checkbox = ({ label, checked, onChange, isDisabled, ...rest }) => {
	return (
		<div className={`checkbox-container ${isDisabled ? 'disabled' : ''}`} onClick={onChange}>
			<input
				className="checkbox-input"
				type="checkbox"
				checked={checked}
				onChange={onChange}
				{...rest}
			/>
			<label className="label">{label}</label>
		</div>
	);
};

Checkbox.propTypes = {
	checked: PropTypes.bool.isRequired,
	onChange: PropTypes.func.isRequired,
	label: PropTypes.node,
	isDisabled: PropTypes.bool
};
Checkbox.defaultProps = {
	isDisabled: false
};
export default Checkbox;
